module.exports = __webpack_public_path__ + "img/取消并清除.6f205854.svg";